import React from 'react';
import PropTypes from 'prop-types';

import './CategoryEventList.sass';

import {connect} from 'react-redux';
import {fetchEventProductsByPreset} from '../../../ducks/eventProducts';

import groupBy from 'lodash-es/groupBy';
import dayjs from 'dayjs';

import Loader from '../../../components/loader/Loader';
import EventProductGroup from '../../../components/eventProducts/EventProductGroup';
import OptionFilters from '../../../components/optionFilters/OptionFilters';
import Caption from '../../../components/caption/Caption';

import {FormattedMessage} from 'react-intl';

@connect(({eventProducts}, {taxon}) => ({
  eventProducts: eventProducts.preset[taxon.eventOptionPreset.id]
}))
export default class CategoryEventList extends React.PureComponent {
  static fetchData = ({dispatch, taxon}) => dispatch(fetchEventProductsByPreset(taxon.eventOptionPreset.id));

  constructor(props) {
    super(props);

    this.state = {options: {}, currentTime: Date.now()};
  }

  updateCurrentTime = () => this.setState({ currentTime: Date.now() });

  componentDidMount() {
    const {dispatch, taxon, eventProducts} = this.props;

    if (eventProducts === undefined) {
      dispatch(fetchEventProductsByPreset(taxon.eventOptionPreset.id));
    }

    this.updateCurrentTime();
    this._timeTicker = setInterval(this.updateCurrentTime, 1000 * 60);
  }

  componentDidUpdate() {
    const {dispatch, taxon, eventProducts} = this.props;

    if (eventProducts === undefined) {
      dispatch(fetchEventProductsByPreset(taxon.eventOptionPreset.id));
    }
  }

  componentWillUnmount() {
    clearInterval(this._timeTicker);
  }

  render() {
    const {taxon, eventProducts} = this.props;
    const {options, currentTime} = this.state;

    if (!eventProducts) {
      return <Loader block/>;
    }

    const filteredEventGroups = eventProducts.filter(
      ({optionValues}) => Object.entries(options)
        .filter(([filter, value]) => !!value)
        .every(([filter, value]) => optionValues.some(({optionId, id}) => optionId == filter && id == value))
    );

    const flatEvents = filteredEventGroups
      .reduce(
        (acc, {id, occurrences, productVariant, optionValues}) =>
          occurrences.map(occurrence => ({
            id, occurrence, productVariant, optionValues,
            disabled: Date.parse(occurrence) < currentTime
          })).concat(acc),
        []
      ).filter(
        ({occurrence}) => dayjs(occurrence).subtract(8, 'day').isBefore(currentTime, 'day')
      ).sort(
        (a, b) => (Date.parse(a.occurrence) - Date.parse(b.occurrence)) || a.productVariant.id - b.productVariant.id
      );

    const groupedEventMap = groupBy(flatEvents, ({occurrence}) => dayjs(occurrence).startOf('day'));

    const groupedEventList = Object.entries(groupedEventMap)
      .map(
        ([groupDate, groupEvents]) => ([new Date(groupDate), groupEvents])
      )
      .sort(
        ([groupDateA], [groupDateB]) => groupDateA - groupDateB
      );

    return (
      <div className="category-events">
        <div className="category-events__filters">
          <OptionFilters
            filters={taxon.eventOptionPreset.options}
            values={options}
            onChange={options => this.setState({options})}
          />
        </div>

        {!!groupedEventList.length ? (
          groupedEventList.map(([eventGroupDate, eventGroup]) => (
            <EventProductGroup
              key={eventGroupDate.toString()}
              presetId={taxon.eventOptionPreset.id}
              date={eventGroupDate}
              events={eventGroup}
            />
          ))
        ) : (
          <Caption>
            <FormattedMessage id="page.category.no-match"/>
          </Caption>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/categoryPage/categoryEventList/CategoryEventList.js